<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination :total="pagination.total" :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize" @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler"
        @saveTags="saveTagsHandler" />
    </template>
    <template slot="table-component">
      <kendo-grid-component 
        v-model="selected" 
        :value-key="['IdCliente', 'IdCifEmpresa', 'NumSerieFactura', 'FechaExpedicion', 'IdEstadoVerifactu']"
        :id-vista="idVista"
        :spanish="spanish" 
        :data="data" 
        :kendo="kendo"
        :loading="isGeneralLoading" 
        :selectedField="selectedField" 
        @datastatechange="dataStateChange"
        @actionclick="openPath">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <div class="mt-5 mb-5"></div>
          <base-button-responsive mode="primary" :text="labelBtnExcel" icon="excelxls" @click="exportExcel"
            :loading="isGeneralLoading || loader" :disabled="loader" />
        </template>
      </base-footer>
      <base-table-select-actions-expand :baseDropDownVisible="isMoreActionsVisible" :visibility="hasSelected"
        :selected="rowsSelected" :total="rowsTotal">
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesGeneral" :key="action.IdAccion">
            <base-button-item-list v-if="showAction(action)" theme="dark" @click="executeAction(action)">
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" />
              <div class="w-72 text-left">
                {{ action.Descripcion }}
              </div>
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <Dialog :title="$t('groups.unlink_groups')" :visible.sync="showModalUnlinkGroups" width="40%" custom-class="min-width-dialog"
        center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkGroups
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalUnlinkGroups = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { unlinkGroupsHandler(); showModalUnlinkGroups = false }" />
          </div>
        </template>
      </Dialog>
      <invoice-link-groups-dialog :dialogOpen="showModalLinkGroups" multiple :idCliente="firstIdCliente" @toggleDialog="showModalLinkGroups = false"
        @applyDialog="(grupos) => { applyLinkHandler(grupos); showModalLinkGroups = false }" />
      <invoice-link-groups-dialog :dialogOpen="showModalLinkGroupsReasig" :idCliente="firstIdCliente"
        @toggleDialog="showModalLinkGroupsReasig = false"
        @applyDialog="(grupos) => { applyLinkReasignHandler(grupos); showModalLinkGroupsReasig = false }" />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler"
        :status="status" />
      <create-search-dialog :numberSearches="numberSearches" :idVista="idVista" :dialogOpen="saveSearchDialog"
        :tags="tags" @toggleDialog="toggleDialogSearches" @applyDialog="applySearchHandler" />
      <filter-panel-searches ref="filterPanelSearches" :idVista="idVista" :vuexnamespace="vuexnamespace"
        :panelOpen="searchesPanel" @togglePanel="toggleSearchesDialog" @applyFilters="applyFiltersHandler"
        @updateNumberSearches="updateNumberSearches" />
    </template>
  </list-layout>
</template>

<script>
import { i18n } from '@/i18n'
import { Dialog } from 'element-ui'


import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/VerifactusFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import InvoiceLinkGroupsDialog from '@/components/InvoiceLinkGroupsDialog.vue'

import { getRegistrosVerifactuPag } from '@/services/verifactu/getRegistrosVerifactuPag'
import { archivarRegistro } from '@/services/verifactu/archivarRegistro'
import { desarchivarRegistro } from '@/services/verifactu/desarchivarRegistro'
import { getRegistrosVerifactuExcel } from '@/services/verifactu/getRegistrosVerifactuExcel'
import { linkVerifactuGroupReasign } from '@/services/configurations/groups/linkVerifactuGroupReasign'
import { linkVerifactuGroupMultiple } from '@/services/configurations/groups/linkVerifactuGroupMultiple'
import { unlinkVerifactuGroupMultiple } from '@/services/configurations/groups/unlinkVerifactuGroupMultiple'

export default {
  name: 'veri-factu-list-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    Dialog,
    InvoiceLinkGroupsDialog
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 93,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // Link grupos
      showModalLinkGroups: false,
      showModalUnlinkGroups: false,
      showModalLinkGroupsReasig: false,
      // All
      estadosPorAccion: [],
      loader: false,
      spanish: true,
      header: {
        title: i18n.t('verifactu.header'),
        icon: 'verifactu',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'verifactu',
      hasClientFilterData: false,
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAccionesCliente: [
        { IdAccion: 102, Descripcion: i18n.t('groups.reasig') },
        { IdAccion: 100, Descripcion: i18n.t('groups.link_groups') },
      ],
      listaAccionesComunes: [
        { IdAccion: 101, Descripcion: i18n.t('groups.unlink_groups') },
      ],
      listaAccionesArchivo: [
        { IdAccion: 103, Descripcion: 'Archivar registro' },
        { IdAccion: 104, Descripcion: 'Desarchivar registro' }
      ],
      status: null,
      selectedAction: null,
      invoicesActions: null,
      isNotice: false,
      noticeType: '',
      processMessageUnlinkGroups: i18n.t('app.unlink_all_entity_confirmation', { entity: i18n.t('groups.header').toLowerCase(), from: i18n.t('verifactu.register').toLowerCase() }),
    }
  },
  computed: {
    isClientFilterActive () {
      return this.$store.getters[this.vuexnamespace + '/isClientFilterActive']
    },
    actualFilterNav () {
      return this.$store.getters['app/idClienteFilterVNav']
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isMoreActionsVisible: function () {
      return this.accionesGeneral !== undefined && this.accionesGeneral.length > 0
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      var tags = this.$store.getters[this.vuexnamespace + '/getTags']
      if (this.status !== undefined && this.status !== 99999) {
        tags = tags.filter(x => x[0] !== 'estadoExtra')
        if (this.status !== 6) {
          tags = tags.filter(x => !['fechaRechazoDesde', 'fechaRechazoHasta', 'motivoRechazo'].includes(x[0]))
        }
        if (this.status !== 7) {
          tags = tags.filter(x => !['fechaPagoDesde', 'fechaPagoHasta'].includes(x[0]))
        }
      }
      return tags
      // return this.status === undefined || this.status === 99999 ? tags : tags.filter(x => x[0] !== 'estadoExtra')
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function () {
      return (IdAccion) =>
        IdAccion === 3 ? 'trash'
          : IdAccion === 100 ? 'groupadd' // Manual
            : IdAccion === 101 ? 'groupremove' // Manual
              : IdAccion === 102 ? 'groupchange' // Manual
                : IdAccion === 200 ? 'download'
                  : 'changestatus'
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isInvoicesGeneral: function () {
      return (this.status === undefined || this.status === 99999) && (this.noticeType === '' || this.noticeType === undefined)
    },
    // Genera las acciones posibles comunes de los elementos seleccionados
    accionesBySelected: function () {
      const objAcciones = { Acciones: [] }
      if (this.selected.length > 0) {
        this.estadosPorAccion.forEach(estadoPorAccion => {
          if (this.selected.length === this.selected.filter(x => estadoPorAccion.estados.includes(x.idEstado)).length) {
            objAcciones.Acciones.push({ Descripcion: estadoPorAccion.Descripcion, IdAccion: estadoPorAccion.IdAccion })
          }
        })
      }
      return objAcciones
    },
    userHasAllPermActions () {
      return [3, 8].includes(this.role)
    },
    // Generacion general de acciones
    accionesGeneral: function () {
      let acciones = []

      // Si hay seleccion:
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        // Comprobamos mismo cliente para añadir acciones comunes de cliente
        const idCliente = this.selected[0].IdCliente
        if (this.selected.length === this.selected.filter(x => x.IdCliente === idCliente).length) {
          // Añadimos las acciones comunes de cliente
          if (!this.isRoleUserOrConsulta) acciones = this.listaAccionesCliente
        }

        // Comprobamos si es estado archivado para añadir acciones de archivo
        if (this.selected.length === this.selected.filter(x => [31, 32, 33].includes(x.IdEstadoVerifactu)).length) {
          // Añadimos las acciones de archivo
          if (!this.isRoleUserOrConsulta) acciones = acciones.concat(this.listaAccionesArchivo.filter(x => x.IdAccion === 104))
        }
        if (this.selected.length === this.selected.filter(x => [22, 23, 24].includes(x.IdEstadoVerifactu)).length) {
          // Añadimos las acciones de archivo
          if (!this.isRoleUserOrConsulta) acciones = acciones.concat(this.listaAccionesArchivo.filter(x => x.IdAccion === 103))
        }

        // Añadimos las acciones estaticas
        if (!this.isRoleUserOrConsulta) acciones = acciones.concat(this.listaAccionesComunes)
      }

      // Si no es consulta añadimos las acciones => Vista general: por seleccion, Vista de estado: por estado
      if (this.role !== 4) {
        if (this.isInvoicesGeneral) {
          acciones = this.accionesBySelected.Acciones.concat(acciones)
        } else {
          if (this.invoicesActions !== null && this.invoicesActions !== undefined) {
            acciones = this.invoicesActions.Acciones.concat(acciones)
          }
        }
      }


      // Accion descarga local de adjuntos (para todos incluido Consulta)
      // if (this.selected.length === this.selected.filter(x => x.idEstado === 2 || x.idEstado === 7 || x.idEstado === 10 || x.idEstado === 11).length) acciones.push({ Descripcion: i18n.t('app.download_documents'), IdAccion: 200 })

      // Eliminamos borrar para rol Usuario y Consulta
      if (this.isRoleUserOrConsulta) acciones = acciones.filter(x => x.IdAccion !== 3)
      return acciones
    },
    userGroups: function () {
      return this.$store.getters['auth/user']?.Grupos
    },
    firstRegisterSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        return { 
          IdCliente: this.selected[0].IdCliente
        }
      }
      return 0
    },
    firstIdCliente () {
      return this.firstRegisterSelected?.IdCliente
    },
  },
  watch: {
    // $route: 'routerChangeHandler',
    $route (to, from) {
      this.checkIsNotice(to, from)
      this.updateOnRouteChange(to, from)
      this.routerChangeHandler()
    },
    actualFilterNav: async function () {
      if (this.actualFilterNav === null || this.actualFilterNav === undefined || this.actualFilterNav === '') {
        await this.removeAllTagsHandler()
      }
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      // [TMP FIX] recargar data (Deja tiempo suficiente para esperar a getestadosdescarga)
      setTimeout(() => {
        this.routerChangeHandler()
      }, 1000)
    },
  },
  created: async function () {
    this.status = this.$route.meta.status
    this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)

    if (this.$route.params.data) {
      this.filterByParamsData()
    }

    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      console.error(i18n.t('feedback.error.noticetype_not_found_error'))
    } else {
      this.isNotice = false
      this.noticeType = ''
      this.header.title = i18n.t('verifactu.header')
    }
    // this.kendo = this.$store.getters[this.vuexnamespace + '/getKendo']
  },
  mounted: async function () {
    this.status = parseInt(this.$store.getters[this.vuexnamespace + '/getMenuType'])
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    if (this.actualFilterNav && this.isClientFilterActive && !this.hasClientFilterData) {
      const filter = this.masterFilters
      filter.idCliente = { label: i18n.t('clients.entity_name'), value: this.actualFilterNav }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
    }
    if (this.status !== undefined && this.status !== 99999) {
      this.downloadInvoiceDataByStatus()
    } else {
      this.data = await this.applyFilters()
    }
  },
  methods: {
    // Genera los estados por accion, de las acciones por estado
    generateEstadosPorAccion: function () {
      const estadosPorAccion = []
      this.invoicesActions.forEach(estadoAccion => {
        estadoAccion.Acciones.forEach(accion => {
          if (estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion).length === 0) {
            const accionTMP = accion
            accionTMP.estados = []
            estadosPorAccion.push(accionTMP)
          }
          if (!estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.includes(estadoAccion.idEstado)) {
            estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.push(estadoAccion.idEstado)
          }
        })
      })
      this.estadosPorAccion = estadosPorAccion
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'company') {
            const cif = { label: i18n.t('companies.companyName'), value: filter.data.label }
            filters.NombreCIF = cif
          } else if (filter.type === 'cliente') {
            this.hasClientFilterData = true
            const cliente = { label: i18n.t('clients.entity_name'), value: { Nombre: filter.data.label, idCliente: filter.data.id } }
            filters.empresa = cliente
          } else {
            filters[filter.type] = filter.data
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    checkIsNotice: function (to, from) {
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        console.error(i18n.t('feedback.error.noticetype_not_found_error'))
      } else {
        this.isNotice = false
        this.noticeType = ''
        this.header.title = i18n.t('verifactu.header')
      }
    },
    updateOnRouteChange: async function (to, from) {
      this.status = parseInt(to.meta.status)
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      // this.$store.commit(this.vuexnamespace + '/resetPaginationInfo')
      if (to.meta && to.meta.status !== undefined && to.meta.status !== 99999) {
        this.downloadInvoiceDataByStatus()
      } else {
        this.data = await this.applyFilters()
      }
    },
    routerChangeHandler: function (to, from) {
      this.resetinvoicesActions()
      if (this.status !== undefined && this.status !== 99999) {
        this.invoicesActions = this.$store.getters['app/actionsForSelect'](this.status, 'Verifactu')
      } else {
        this.resetinvoicesActions()
      }
    },
    resetinvoicesActions: function () {
      this.invoicesActions = this.$store.getters['app/actionsForSelect'](null, 'Verifactu')
      this.generateEstadosPorAccion() // Necesario para logica automatica de compatibilidad de acciones
    },
    openPath: function (event) {
      const status = this.status === 99999 ? event.dataItem.IdEstadoVerifactu : this.status
      this.$router.push(
        {
          name: 'verifactu/details',
          params: {
            IdCliente: event.dataItem.IdCliente,
            IdCifEmpresa: event.dataItem.IdCifEmpresa,
            NumSerieFactura: event.dataItem.NumSerieFactura,
            FechaExpedicion: event.dataItem.FechaExpedicion,
            type: status,
            CSVZC: event.dataItem.CSVZC,
            asunto: event.dataItem.NumSerieFactura,
            fromGeneral: this.status === 99999 || this.status === '99999',
          }
        }
      )
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    dataStateChange: async function () {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      return {
        archivados: data.Archivado ? data.Archivado.value : this.isArchivedStatus(this.status),
        idCliente: data.idCliente ? data.idCliente.value.idCliente : null,
        idDistribuidor: data.idDistribuidor ? data.idDistribuidor.value.idDistribuidor : null,
        idCifEmpresa: data.idCifEmpresa ? data.idCifEmpresa.value : null,
        CIF: data.CIF ? data.CIF.value : null,
        CSVZC: data.CSVZC ? data.CSVZC.value : null,
        CSVAEAT: data.CSVAEAT ? data.CSVAEAT.value : null,
        CuotaTotalDesde: data.CuotaTotalDesde ? data.CuotaTotalDesde.value : null,
        CuotaTotalHasta: data.CuotaTotalHasta ? data.CuotaTotalHasta.value : null,
        Empresa: data.Empresa ? data.Empresa.value.Nombre : null,
        FechaAltaDesde: data.FechaAltaDesde ? data.FechaAltaDesde.value : null,
        FechaAltaHasta: data.FechaAltaHasta ? data.FechaAltaHasta.value : null,
        FechaExpedicionDesde: data.FechaExpedicionDesde ? data.FechaExpedicionDesde.value : null,
        FechaExpedicionHasta: data.FechaExpedicionHasta ? data.FechaExpedicionHasta.value : null,
        FechaNotificacionDesde: this.status !== 25 && data.FechaNotificacionDesde ? data.FechaNotificacionDesde.value : null,
        FechaNotificacionHasta: this.status !== 25 && data.FechaNotificacionHasta ? data.FechaNotificacionHasta.value : null,
        HuellaRegistro: data.HuellaRegistro ? data.HuellaRegistro.value : null,
        IdAccionVerifactu: data.IdAccionVerifactu ? data.IdAccionVerifactu.value : null,
        IdEstadoVerifactu: (this.status !== undefined && this.status !== 99999) ? this.status : data.IdEstadoVerifactu ? data.IdEstadoVerifactu.value : null,
        IdTipoFactura: data.IdTipoFactura ? data.IdTipoFactura.value : null,
        ImporteTotalDesde: data.ImporteTotalDesde ? data.ImporteTotalDesde.value : null,
        ImporteTotalHasta: data.ImporteTotalHasta ? data.ImporteTotalHasta.value : null,
        NumSerieFactura: data.NumSerieFactura ? data.NumSerieFactura.value : null,
        SIF: data.SIF ? data.SIF.value : null,
        RefExterna: data.RefExterna ? data.RefExterna.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        nombreGrupoNoPropietario: data.nombreGrupoNoPropietario ? data.nombreGrupoNoPropietario.value : null,
        isFixableError: data.EsSubsanable ? data.EsSubsanable.value : null,
        ErrorMessage: data.MensajeError ? data.MensajeError.value : null,
      }
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loader = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const orders = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = {
        order: orders.order,
        grupos: objColumnas,
      }

      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => {
          return {
            IdCliente: x.IdCliente,
            IdCifEmpresa: x.IdCifEmpresa,
            NumSerieFactura: x.NumSerieFactura,
            FechaExpedicion: x.FechaExpedicion,
          }
        })
        payload.listaIDs = selectedIDs
      }
      let response
      try {
        response = await getRegistrosVerifactuExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'verifactu.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loader = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      this.$store.commit(this.vuexnamespace + '/setClientFilterActive', !!((data.idCliente && data.idCliente.value.idCliente === this.actualFilterNav?.idCliente) || (this.hasClientFilterData)))
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta

      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }

      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getRegistrosVerifactuPag(orders, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      data.respuesta.forEach(o => {
        // o.FechaFactura = moment(o.FechaFactura).format('DD-MM-YYYY HH:mm')
      })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    tableSortByChangeHandler: async function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters()
    },
    unselect: function () {
      this.selected = []
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 100) { // vincular grupos
        this.toggleDialogs()
      } else if (this.selectedAction.IdAccion === 101) { // desvincular grupos
        this.unlinkGroups()
      } else if (this.selectedAction.IdAccion === 102) { // Reasignar propietario a grupo
        this.toggleDialogReasign()
      } else if (this.selectedAction.IdAccion === 103) {
        this.archiveRegistroVerifactu()
      } else if (this.selectedAction.IdAccion === 104) {
        this.unarchiveRegistroVerifactu()
      } 
    },
    unlinkGroups: async function () {
      if (this.showModalUnlinkGroups) return
      this.showModalUnlinkGroups = !this.showModalUnlinkGroups
    },
    toggleDialogs: function () {
      if (this.showModalLinkGroups) return
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    toggleDialogReasign () {
      if (this.showModalLinkGroupsReasig) return
      this.showModalLinkGroupsReasig = !this.showModalLinkGroupsReasig
    },
    downloadInvoiceDataByStatus: async function () {
      // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      try {
        const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
        filter.estado = { label: i18n.t('app.status'), value: this.status }

        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
        this.invoicesActions = this.$store.getters['app/actionsForSelect'](this.status, 'Verifactu')
        if (this.status !== undefined && this.status !== 99999) {
          this.header.title = this.invoicesActions.InfoAdicional
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
    showAction: function (action) {
      return !(action.IdAccion === 12 && this.selected.some(x => x.PgeKey === 'EXTERNO'))
    },
    applyLinkHandler: async function (grupos) {
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idsVerifactu: [] }
        payload.idGrupos = grupos
        payload.idsVerifactu = this.selected.map(x => { return { IdCliente: x.IdCliente, IdCifEmpresa: x.IdCifEmpresa, NumSerieFactura: x.NumSerieFactura, FechaExpedicion: x.FechaExpedicion } })
        const response = await linkVerifactuGroupMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
        }
        this.data = await this.applyFilters()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.selected = []
      }
    },
    applyLinkReasignHandler: async function (grupo) {
      try {
        this.showModalLinkGroupsReasig = false
        this.$store.commit('setIsLoading', true)
        const payload = { idsVerifactu: [], idGrupo: grupo }
        payload.idsVerifactu = this.selected.map(x => { return { IdCliente: x.IdCliente, IdCifEmpresa: x.IdCifEmpresa, NumSerieFactura: x.NumSerieFactura, FechaExpedicion: x.FechaExpedicion } })
        const response = await linkVerifactuGroupReasign(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_reasigned_msg'), 'success')
        }
        this.data = await this.applyFilters()
      } catch {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.selected = []
      }
    },
    unlinkGroupsHandler: async function () {
      try {
        this.showModalUnlinkGroups = false
        this.$store.commit('setIsLoading', true)
        const payload = this.selected.map(x => { return { IdCliente: x.IdCliente, IdCifEmpresa: x.IdCifEmpresa, NumSerieFactura: x.NumSerieFactura, FechaExpedicion: x.FechaExpedicion } })
        const response = await unlinkVerifactuGroupMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_reasigned_msg'), 'success')
        }
        this.data = await this.applyFilters()
      } catch {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.selected = []
      }
    },
    archiveRegistroVerifactu: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = this.selected.map(x => { return { IdCliente: x.IdCliente, IdCifEmpresa: x.IdCifEmpresa, NumSerieFactura: x.NumSerieFactura, FechaExpedicion: x.FechaExpedicion } })
        const response = await archivarRegistro(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback('Archivado correctamente', 'success')
        }
        this.data = await this.applyFilters()
      } catch {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.selected = []
      }
    },
    unarchiveRegistroVerifactu: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = this.selected.map(x => { return { IdCliente: x.IdCliente, IdCifEmpresa: x.IdCifEmpresa, NumSerieFactura: x.NumSerieFactura, FechaExpedicion: x.FechaExpedicion } })
        const response = await desarchivarRegistro(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback('Desarchivado correctamente', 'success')
        }
        this.data = await this.applyFilters()
      } catch {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.selected = []
      }
    },
    isArchivedStatus: function (status) {
      if (this.status !== undefined && this.status !== 99999) {
        return [31, 32, 33].includes(status)
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped></style>
